import Http from 'vue-resource/src/http'
import {ref, computed, markRaw} from 'vue'
import {createAppComponent} from '@tfx/common/initializers'

import {store} from '../../store/index'

import {app} from 'tfx-common/app'
import dialogsMixins from 'tfx-common/modules/dialogs-mixins'

const overlayElSelector = '.global-overlay'
const containerElSelector = '.modal-container'

const last = function (els) {
  return els[els.length - 1]
}

window.addEventListener('keyup', ({keyCode, which}) => {
  if (keyCode === 27 || which === 27) {
    if (store.state.confirmationPopup?.open) {
      store.dispatch('confirmationPopup/close')
    } else {
      const reportFormCloseEl = document.querySelector('.report-form .report-form_close')
      if (reportFormCloseEl) {
        reportFormCloseEl.click()
      } else {
        const nodes = document.querySelectorAll('#modalcontainer:not(.modal-container-hide) .modal-window.modal-displayed')
        if (nodes.length) {
          const last = nodes[nodes.length - 1]
          last.querySelector('[data-modal-action=close]')?.click()
        }
      }
    }
  }
})

const restoreStateAfterDialogClose = function () {
  const returnUrlDiv = Array.from(document.querySelectorAll('#return-cpath-div'))
  if (returnUrlDiv.length > 0) {
    const returnUrl = last(returnUrlDiv)
    history.replaceState(null, '', returnUrl.dataset.returnCpath)

    returnUrlDiv.forEach((el) => {
      el.parentElement.removeChild(el)
    })
  }
}

const state = ref({
  showDialog: false,
  openedDialog: [],
  closeDialogCallback: null,
  modals: [],
  isAllErbModalsClosed: false
})

export const showModalDialog = computed(() => {
  return state.value.modals.length > 0
})

export const currentDialog = computed(() => {
  return state.value.modals[state.value.modals.length - 1]
})

export const modalDialogs = computed(() => {
  return state.value.modals
})

export const isAllErbModalsClosed = computed(() => {
  return state.value.isAllErbModalsClosed
})

export function showModal(props) {
  if (typeof props.dialogType === 'object') {
    state.value.modals.push({
      dialogType: markRaw(props.dialogType),
      currentProperties: props.currentProperties
    })
  } else {
    state.value.modals.push(props)
  }
}

export function openModalDialog(component, props = {}) {
  showModal({
    dialogType: component,
    currentProperties: props
  })
}

export function showConfirmationDialog({messages, onClose}) {
  showModal({
    currentProperties: {
      lines: messages,
      dialogCallback: onClose
    },
    dialogType: 'confirmation-dialog'
  })
}

export function showClientConfirmationDialog({title, html, confirmCallback, cancelCallback = undefined}) {
  showModal({
    currentProperties: {title, html, confirmCallback, cancelCallback},
    dialogType: 'messages-confirmation-dialog'
  })
}

export function dialogCloseModal() {
  if (state.value.modals.length === 0 && state.value.openedDialog.length > 0) {
    const dialog = state.value.openedDialog.pop()
    dialog.classList.toggle('modal-displayed')
    if (dialog.hasAttribute('remove-on-close')) {
      if (dialog.__tfx_vue_component?.__app) {
        dialog.__tfx_vue_component.__app.unmount()
      }
      window.setTimeout(() => {
        // element may be already removed by vue
        // either by calling unmount on modal's app (loadModal modals)
        // or by v-if="!isAllErbModalsClosed" (erb modals)
        dialog.parentNode?.removeChild?.(dialog)
      }, 0)
    }
  } else {
    // probably dead code
    const dialog = state.value.modals.pop()
    if (dialog && dialog.$el) {
      dialog.$el.classList.toggle('modal-displayed')
      dialog.destroy()
    }
  }

  if (state.value.modals.length === 0 && state.value.openedDialog.length === 0) {
    state.value.isAllErbModalsClosed = true
    restoreStateAfterDialogClose()

    document.body.classList.remove('overflow-hidden')
    document.querySelector(containerElSelector).classList.add('modal-container-hide')
    document.querySelector(overlayElSelector).classList.remove('global-overlay-show')
  }
  return true
}

export function registerOpenDialog({el}) {
  if (el.dataset && el.dataset.dialogStack == 'replace') {
    const index = state.value.openedDialog.findIndex((dialog) => dialog.id === el.id)
    if (index >= 0) state.value.openedDialog.splice(index, 1)
  }
  state.value.openedDialog.push(el)
  _prepareModal({el})

  if (!state.value.closeDialogCallback) {
    state.value.closeDialogCallback = function (event) {
      event.preventDefault()
      dialogCloseModal()
    }
  }

  el.addEventListener('click', (e) => {
    if (e.target.closest('[data-modal-action=close]')) {
      state.value.closeDialogCallback(e)
    }
  })
}

export function loadModal({el, closeAll, alert, callback}) {
  let href
  if (typeof el === 'string' || el instanceof String) {
    href = el
  } else {
    href = el.href
  }
  if (typeof alert === 'string' && alert.length > 0) {
    app.notify('Error', {type: 'error', text: alert})
  }
  let url
  if (href.indexOf('?') > 0) {
    url = href + '&dialog=1'
  } else {
    url = href + '?dialog=1'
  }

  Http.get(url).then(
    (response) => {
      if (response.headers.get('content-type').startsWith('application/javascript')) {
        eval(response.body)
        if (callback) {
          callback(null)
        }
      } else if (response.headers.get('content-type').startsWith('application/json')) {
        if (response.body) {
          if (response.body.alert) {
            app.notify(response.body.alert, {type: 'error'})
          } else if (response.body.notice) {
            app.notify(response.body.notice, {type: 'success'})
          }
        }
        if (callback) {
          callback(null)
        }
      } else {
        const componentApp = createAppComponent({
          store,
          mixins: [dialogsMixins],
          template: response.body
        })

        const component = componentApp.mount(document.createElement('div'))
        component.__app = componentApp // used to unmount the modal
        const container = document.querySelector(containerElSelector)

        const dialogId = component.$el.id
        if (dialogId) {
          const oldDialog = container.querySelector(`#${dialogId}`)
          if (oldDialog) container.removeChild(oldDialog)
        }

        container.appendChild(component.$el)

        if (callback) {
          callback(component)
        }
      }
    },
    (response) => {
      if (response.body && response.body.errors) {
        app.notify(response.body.errors.join('. '), {type: 'error'})
      } else {
        app.notify('Error', {type: 'error'})
      }
    }
  )
  if (closeAll) {
    _closeAll()
  }
}

export function resetDialogs() {
  state.value.isAllErbModalsClosed = false
  state.value.openedDialog = []
  state.value.modals = []
}

function _closeAll() {
  state.value.openedDialog.forEach((modal) => {
    dialogCloseModal()
  })
  state.value.modals.forEach((modal) => {
    dialogCloseModal()
  })
}

// We should fix this. and remove export because _ methods supposed to be private
export function _prepareModal({el}) {
  document.body.classList.add('overflow-hidden')
  document.querySelector(containerElSelector).classList.remove('modal-container-hide')
  document.querySelector(overlayElSelector).classList.add('global-overlay-show')
  el.classList.add('modal-displayed')

  // TODO: probably nextTick?
  setTimeout(() => {
    el.classList.add('modal-show-window')
    _updateScrollbar()
  }, 100)
}

function _updateScrollbar() {
  if (app.scrollbarComponent) {
    app.scrollbarComponent.ps.forEach((elm) => {
      if (elm.element.classList.contains('modal-container')) {
        setTimeout(() => {
          elm.update() // This is updating method of scrollbar
        }, 0)
      }
    })
  }
}
